<template>
  <div>
    <el-dialog
      :append-to-body="true"
      :title="$t('receivablePayable.ConfirmThePayableData')"
      :visible.sync="isBool"
      width="50%"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div v-loading="confirmLoading" style="height: 40vh;overflow: hidden;">
        <el-table :data="batchNumber" border>
          <!--网点名称-->
          <el-table-column v-if="payableType !== 5" :label="$t('login.siteName')" prop="siteName" />
          <!--应付主体-->
          <el-table-column v-if="payableType === 5" :label="$t('basicData.PayablePrincipal')" prop="providerName" />
          <!--派送操作人-->
          <el-table-column v-if="payableType === 3" :label="$t('basicData.派送操作人')" prop="dispatcherName">
            <template slot-scope="scope"><div>{{ scope.row.dispatcherName.join('，') }}</div></template>
          </el-table-column>
          <!--费用类型-->
          <el-table-column v-if="[4,7].includes(payableType)" :label="$t('basicData.ExpenseType')" prop="feeCodeList">
            <template slot-scope="scope"><div>{{ scope.row.feeName.join('，') }}</div></template>
          </el-table-column>
          <!--运输类型-->
          <el-table-column v-if="payableType === 5" :label="$t('basicData.transportType')" prop="routeTypeName">
            <template slot-scope="scope"><div>{{ scope.row.routeTypeName.join('，') }}</div></template>
          </el-table-column>
          <!--订单数量-->
          <el-table-column :label="$t('receivablePayable.TheNumberOfOrders')" prop="orderQty" />
          <!--应付总金额-->
          <el-table-column :label="$t('receivablePayable.TheTotalAmountDue')" prop="totalAmount" />
        </el-table>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <!--取 消-->
        <el-button
          size="small"
          :disabled="confirmLoading"
          @click="determineGenerationFee(1)"
        >{{ $t('basicData.Cancel') }}</el-button>
        <!--确定生成费用-->
        <el-button
          size="small"
          type="primary"
          :loading="confirmLoading"
          @click="determineGenerationFee(2)"
        >
          {{ $t('basicData.determine') }}
        </el-button>
      </span>
    </el-dialog>

    <!--账单生成成功-->
    <el-dialog
      :title="$t('receivablePayable.billHasBeenSuccess')"
      :visible.sync="showBillHasBeenSuccess"
      width="50%"
    >
      <el-table :data="batchTableData" border>
        <!--网点名称-->
        <el-table-column
          v-if="payableType !== 5"
          :label="$t('collectionCenter.siteName')" prop="siteName"
          width="160"
        />
        <!--应付主体-->
        <el-table-column
          v-if="payableType === 5"
          :label="$t('basicData.PayablePrincipal')" prop="providerName" width="160"
        />
        <!--派送操作人-->
        <el-table-column
          v-if="payableType === 3"
          :label="$t('basicData.派送操作人')" prop="dispatcherName" width="160"
        >
          <template slot-scope="scope"><div>{{ scope.row.dispatcherName.join('，') }}</div></template>
        </el-table-column>
        <!--费用类型-->
        <el-table-column v-if="[4,7].includes(payableType)" :label="$t('basicData.ExpenseType')" prop="feeCodeList">
          <template slot-scope="scope"><div>{{ scope.row.feeName.join('，') }}</div></template>
        </el-table-column>
        <!--运输类型-->
        <el-table-column v-if="payableType === 5" :label="$t('basicData.transportType')" prop="routeTypeName">
          <template slot-scope="scope"><div>{{ scope.row.routeTypeName.join('，') }}</div></template>
        </el-table-column>
        <!--订单数量-->
        <el-table-column :label="$t('receivablePayable.TheNumberOfOrders')" prop="orderQty" width="160" />
        <!--应付总金额-->
        <el-table-column :label="$t('receivablePayable.TheTotalAmountDue')" prop="totalAmount" width="160" />
        <!--账单批次号-->
        <el-table-column :label="$t('receivablePayable.BillingBatchNumber')" prop="billBatchNumbers" width="260">
          <template slot-scope="scope">
            <div v-if="scope.row.billBatchNumbers && scope.row.billBatchNumbers.length > 0">
              {{ scope.row.billBatchNumbers.join('，') }}
            </div>
          </template>
        </el-table-column>
        <!--异常原因-->
        <el-table-column :label="$t('collectionCenter.ReasonForAbnormal')" prop="failureReason" width="200" />
        <!--操作-->
        <el-table-column :label="$t('collectionCenter.operation')" width="180" fixed="right">
          <template slot-scope="scope">
            <!--无批次号时不展示复制按钮-->
            <el-button
              v-if="scope.row.billBatchNumbers && scope.row.billBatchNumbers.length > 0"
              type="primary" size="small" plain
              @click="copyBatchNumber(scope.row.billBatchNumbers)"
            >{{ $t('receivablePayable.CopyTheBatchNumber') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  payableSiteBillBatchGenerateBillNumberApi,
  payableTransportExpenseBatchGenerateBillNumberApi
} from '@/api/finance/receivables';
import { copyData } from '@/utils/copyData';
import { buildPayableBillRows } from '@/views/finance/payableManage/feesPayable/component/AccountsPayable/utils.js';

export default {
  name: '',
  data() {
    return {
      isBool: false,
      batchNumber: [],
      payableType: 1,
      param: null,
      showBillHasBeenSuccess: false,
      batchTableData: [],
      confirmLoading: false // 「确定生成费用」独立 loading，防止重复提交
    };
  },

  methods: {
    open(list, param, payableType) {
      this.batchNumber = buildPayableBillRows(list);
      this.payableType = payableType;
      this.param = param;
      this.isBool = true;
    },
    // 确定生成费用
    async determineGenerationFee(type) {
      if (type === 1) {
        this.isBool = false;
        return false;
      }
      // 请求进行中直接忽略，避免重复生成账单
      if (this.confirmLoading) {
        return false;
      }
      const API = this.payableType === 5 ? payableTransportExpenseBatchGenerateBillNumberApi : payableSiteBillBatchGenerateBillNumberApi;
      this.confirmLoading = true;
      try {
        const res = await API(this.param);
        if (res.code === 200) {
          this.isBool = false;
          this.batchTableData = buildPayableBillRows(res.data);
          this.showBillHasBeenSuccess = true;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.confirmLoading = false;
      }
    },
    // 复制账单批次号
    copyBatchNumber(data) {
      // 无批次号时（按钮已隐藏）兜底，避免 data.join 抛错
      if (!Array.isArray(data) || data.length === 0) {
        return false;
      }
      copyData(data.join(','));
      return true;
    }
  }

};
</script>

<style lang="scss" scoped>
</style>
